import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 4.5C3 3.94772 3.44772 3.5 4 3.5H8C8.55228 3.5 9 3.94772 9 4.5C9 5.05228 8.55228 5.5 8 5.5H6.41421L8.70711 7.79289C9.09763 8.18342 9.09763 8.81658 8.70711 9.20711C8.31658 9.59763 7.68342 9.59763 7.29289 9.20711L5 6.91421V8.5C5 9.05228 4.55228 9.5 4 9.5C3.44772 9.5 3 9.05228 3 8.5V4.5ZM12 5.5C11.4477 5.5 11 5.05228 11 4.5C11 3.94772 11.4477 3.5 12 3.5H16C16.5523 3.5 17 3.94772 17 4.5V8.5C17 9.05228 16.5523 9.5 16 9.5C15.4477 9.5 15 9.05228 15 8.5V6.91421L12.7071 9.20711C12.3166 9.59763 11.6834 9.59763 11.2929 9.20711C10.9024 8.81658 10.9024 8.18342 11.2929 7.79289L13.5858 5.5H12ZM3 12.5C3 11.9477 3.44772 11.5 4 11.5C4.55228 11.5 5 11.9477 5 12.5V14.0858L7.29289 11.7929C7.68342 11.4024 8.31658 11.4024 8.70711 11.7929C9.09763 12.1834 9.09763 12.8166 8.70711 13.2071L6.41421 15.5H8C8.55228 15.5 9 15.9477 9 16.5C9 17.0523 8.55228 17.5 8 17.5H4C3.44772 17.5 3 17.0523 3 16.5V12.5ZM16 11.5C16.5523 11.5 17 11.9477 17 12.5V16.5C17 17.0523 16.5523 17.5 16 17.5H12C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5H13.5858L11.2929 13.2071C10.9024 12.8166 10.9024 12.1834 11.2929 11.7929C11.6834 11.4024 12.3166 11.4024 12.7071 11.7929L15 14.0858V12.5C15 11.9477 15.4477 11.5 16 11.5Z",
  fill: "#717179"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}